interface BillingToggleProps {
  annual: boolean;
  onChange: (annual: boolean) => void;
}

/**
 * Monthly / Annual billing toggle.
 * Shows a "Save ~17%" pill when annual is selected.
 */
export default function BillingToggle({ annual, onChange }: BillingToggleProps) {
  return (
    <div className="flex items-center justify-center gap-4 select-none">
      {/* Monthly label */}
      <button
        type="button"
        onClick={() => onChange(false)}
        className={`font-body text-sm font-medium transition-colors ${
          annual ? 'text-gray-400 hover:text-gray-600' : 'text-navy'
        }`}
      >
        Monthly
      </button>

      {/* Toggle pill */}
      <button
        type="button"
        role="switch"
        aria-checked={annual}
        onClick={() => onChange(!annual)}
        className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 ${
          annual ? 'bg-sage' : 'bg-gray-300'
        }`}
      >
        <span className="sr-only">Toggle annual billing</span>
        <span
          className={`inline-block h-5 w-5 rounded-full bg-white shadow-sm transition-transform ${
            annual ? 'translate-x-8' : 'translate-x-1'
          }`}
        />
      </button>

      {/* Annual label + savings badge */}
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onChange(true)}
          className={`font-body text-sm font-medium transition-colors ${
            annual ? 'text-navy' : 'text-gray-400 hover:text-gray-600'
          }`}
        >
          Annual
        </button>

        <span
          className={`rounded-full px-2 py-0.5 text-xs font-semibold font-body transition-all ${
            annual
              ? 'bg-gold/20 text-gold-dark opacity-100 scale-100'
              : 'opacity-0 scale-95 pointer-events-none'
          }`}
          style={{ color: '#9A7B2C' }}   // darker gold for readability on cream
        >
          Save ~17%
        </span>
      </div>
    </div>
  );
}
